import { Employee } from '@entity/employee';
import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { AbstractCrudMandantService } from '@service/abstract-crud-mandant.service';

@Injectable({
  providedIn: 'root',
})
export class EmployeeService extends AbstractCrudMandantService<Employee> {
  constructor() {
    const httpClient = inject(HttpClient);

    super('employees', httpClient);
  }
}
